import type { BaseResponse } from './types/core/common';
import { createAuthenticatedFetch } from './types/core/common';
import type { ImageAsset } from './types/core/image';

interface ImagesResponse extends BaseResponse {
  data?: ImageAsset[];
}

interface ImageResponse extends BaseResponse {
  data?: ImageAsset;
}

const api = createAuthenticatedFetch();

export const imagesApi = {
  // Récupérer les images d'une entité
  async getEntityImages(entityUuid: string, entityType: string): Promise<ImagesResponse> {
    return api.get<ImagesResponse>(`/images/${entityType}/${entityUuid}`);
  },

  // Uploader une image
  async uploadImage(file: File, entityUuid: string, entityType: string): Promise<ImageResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('entity_uuid', entityUuid);
    formData.append('entity_type', entityType);

    return api.post<ImageResponse>('/images/upload', formData);
  },

  // Supprimer une image
  async deleteImage(imageUuid: string): Promise<void> {
    return api.delete(`/images/${imageUuid}`);
  },

  // Récupérer une image par UUID
  async getImage(imageUuid: string): Promise<ImageResponse> {
    return api.get<ImageResponse>(`/images/${imageUuid}`);
  },

  // Obtenir l'URL d'une image
  getImageUrl(imageUuid: string): string {
    return `/api/images/${imageUuid}/file`;
  },

  // Obtenir l'URL de la miniature
  getThumbnailUrl(imageUuid: string): string {
    return `/api/images/${imageUuid}/thumbnail`;
  },
}; 